<template>
    <div v-if="!canReadProjects" class="area-content-head">
        <div class="no-permission-message">
            Sie haben keine Berechtigung, Projekte zu öffnen.
        </div>
        <head-component />
    </div>

    <div v-else class="area-content-head" :class="{'head-overview':$route.params.id}">
        <div v-if="!$route.params.id" class="head-title">Projekte</div>

        <div v-if="$route.params.id" class="head-toolbar-large">
            <router-link :to="'/Projects/' + $route.params.id + '/' + item.context"
                         v-for="item in visibleItems"
                         :key="item.context"
                         class="head-toolbar-item"
                         :class="{ 'router-link-active': $route.path.match(new RegExp('/' + item.context + '(/|$)','i')) }">
                <div class="head-toolbar-item-icon material-symbols-outlined">{{item.icon}}</div>
                <div v-if="!item.subLabel" class="head-toolbar-item-label">{{item.label}}</div>
                <div v-if="item.subLabel" class="head-toolbar-item-label-main">{{item.label}}</div>
                <div v-if="item.subLabel" class="head-toolbar-item-label-sub">{{item.subLabel}}</div>
            </router-link>
        </div>

        <div v-else class="head-toolbar">
            <div v-if="canCreateProjects"
                 class="head-toolbar-button-compact material-symbols-outlined"
                 @click="addProject"
                 title="Projekt hinzufügen">
                add
            </div>

            <div v-if="canArchiveProjects"
                 class="head-toolbar-button-compact material-symbols-outlined"
                 @click="setArchived = true"
                 title="Projekt archivieren">
                {{showArchived ? 'unarchive' : 'archive'}}
            </div>

            <div v-if="canReadProjects"
                 class="head-toolbar-button-compact material-symbols-outlined"
                 :class="{'border-color-warn':showArchived}"
                 @click="showArchived = !showArchived"
                 title="Archiv anzeigen">
                inventory_2
            </div>
        </div>

        <div v-if="$route.params.id" class="head-placeholder"></div>
        <head-component />
    </div>
</template>

<script lang="js">
    import { defineComponent } from 'vue';
    import headComponent from '../components/head-component.vue';
    import meApi from '../services/MeApi';
    import AppPermissions from '../constants/AppPermissions';

    const items = [
        {
            label: "Info",
            icon: "info",
            context: "",
            stageName: null,
            readPermission: AppPermissions.ProjectsTabsInfo.Read
        },
        {
            label: "Vorankündigung",
            icon: "description",
            stageName: 'Notice',
            context: "notice",
            readPermission: AppPermissions.ProjectsTabsNotice.Read
        },
        {
            label: "Planungsphase",
            subLabel: "SiGe-Plan",
            stageName: 'Planning',
            icon: "space_dashboard",
            context: "sige-plan-planning",
            readPermission: AppPermissions.ProjectsTabsSiGePlan.Read
        },
        {
            label: "Planungsphase",
            subLabel: "Spätere Arbeiten",
            stageName: 'Planning',
            icon: "event_available",
            context: "later-work-planning",
            readPermission: AppPermissions.ProjectsTabsLaterWorkPlanning.Read
        },
        {
            label: "SiGe-Plan",
            icon: "assignment_late",
            stageName: 'SiGePlan',
            context: "sige-plan",
            readPermission: AppPermissions.ProjectsTabsSiGePlan.Read
        },
        {
            label: "Baustellen",
            subLabel: "Ordnung",
            icon: "gavel",
            stageName: 'Inspection',
            context: "order",
            readPermission: AppPermissions.ProjectsTabsOrder.Read
        },
        {
            label: "Protokolle",
            icon: "content_paste",
            stageName: 'Inspection',
            context: "protocol",
            readPermission: AppPermissions.ProjectsTabsProtocol.Read
        },
        {
            label: "Finale Unterlage",
            icon: "history_edu",
            stageName: 'SubsequentWorkDocs',
            context: "final",
            readPermission: AppPermissions.ProjectsTabsFinal.Read
        }
    ];

    export default defineComponent({
        components: {
            headComponent
        },
        data() {
            return {
                items,
                showArchived: false,
                setArchived: false
            };
        },
        computed: {
            canReadProjects() {
                return meApi.hasPermissionSync(AppPermissions.ProjectsOverview.Read);
            },
            canCreateProjects() {
                return meApi.hasPermissionSync(AppPermissions.ProjectsOverview.Create);
            },
            canArchiveProjects() {
                return meApi.hasPermissionSync(AppPermissions.ProjectsOverview.Archive);
            },
            visibleItems() {
                const stages = this.$root?.project?.stages || [];

                return this.items.filter(i => {
                    const stageAllowed = !i.stageName || stages.includes(i.stageName);
                    const permissionAllowed = !i.readPermission || meApi.hasPermissionSync(i.readPermission);
                    return stageAllowed && permissionAllowed;
                });
            }
        },
        watch: {
            "$root.project.stages"() {
                // computed visibleItems reacts automatically
            }
        },
        methods: {
            changeTab(id, tab) {
                this.$router.push("/Projects/" + id + "/" + tab);
            },
            async addProject() {
                if (!this.canCreateProjects)
                    return;

                this.$router.push("/Projects/new");
            }
        }
    });
</script>

<style>
    .no-permission-message {
        padding: 20px;
        background-color: #2a2a2a;
    }
</style>